import { Typography } from '@remarkable/ark-web';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import {
  useChangeEnterpriseSubscriptionBillingInterval,
  useEnterpriseSubscription,
} from 'src/api/queries/enterpriseSubscription';
import { Button, Modal, NotificationBox } from 'src/components';

export function AbortSwitchToMonthlyModal({
  onSuccess,
}: {
  onSuccess: () => void;
}) {
  const updateBillingInterval =
    useChangeEnterpriseSubscriptionBillingInterval();
  const subscription = useEnterpriseSubscription();

  const numberOfCurrentlyCommittedSeats =
    subscription.data?.planCurrent.prices.annual.quantity;

  return (
    <Modal.Content className="flex flex-col items-center gap-32">
      <Modal.Title asChild>
        <Typography as="h2" variant="heading-md" className="text-center">
          Stay on current plan?
        </Typography>
      </Modal.Title>

      <Modal.Description asChild>
        <Typography variant="body-md">
          You have a plan change scheduled for June 22, 2027. If you undo this
          change, you will remain on your current plan.
        </Typography>
      </Modal.Description>

      <div className="mx-auto flex justify-center gap-16">
        <Modal.Close asChild>
          <Button
            variant="tertiary"
            analytics={{
              text: 'Close',
              location: ComponentLocations.ENTERPRISE.MODAL_SWITCH_TO_MONTHLY,
              action: 'dismiss abort switch to monthly plan',
            }}
          >
            Close
          </Button>
        </Modal.Close>

        <Button
          variant="primary"
          loading={updateBillingInterval.isPending}
          analytics={{
            text: 'Stay on annual plan',
            location: ComponentLocations.ENTERPRISE.MODAL_SWITCH_TO_MONTHLY,
            action: 'abort switch to monthly plan',
          }}
          onClick={() =>
            updateBillingInterval.mutate(
              {
                interval: 'annual',
                seats: numberOfCurrentlyCommittedSeats,
              },
              { onSuccess }
            )
          }
        >
          Stay on annual plan
        </Button>
      </div>

      <NotificationBox
        title="Unable to update billing interval"
        error={updateBillingInterval.error}
      />
    </Modal.Content>
  );
}
